import { render, staticRenderFns } from "./BowCallToAction.vue?vue&type=template&id=ed494094&"
import script from "./BowCallToAction.vue?vue&type=script&lang=js&"
export * from "./BowCallToAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports